import React, { memo } from "react";

function TicketsTableHeader() {
    return (
        <thead>
            <tr className="text-dim">
                <th>Ticket Number</th>
                <th>Subject</th>
                <th>Priority</th>
                <th>Request Type</th>
                <th>Date Created</th>
                <th>Source</th>
                <th># of Replies</th>
                <th>Modified</th>
            </tr>
        </thead>
    );
}

export default memo(TicketsTableHeader);
